module.exports = __webpack_public_path__ + "img/cost_icon_16.3ed2b40d.svg";